import React, { useMemo } from 'react';
import { QuickActionButton } from './QuickActionButton';
import {
  chatPageCategories,
  libraryItems,
  dashboardItems,
  LibraryItem,
  ChatPageCategory,
} from '../Library/libraryData';
import { useGetTenantIntegrations } from '../../../onboarding/apis/tenant-integrations';
import { useTranslation } from 'react-i18next';

interface QuickActionButtonsProps {
  onActionClick?: (
    name: string,
    icon: React.ReactNode,
    items: LibraryItem[],
  ) => void;
  isSmallWindow: boolean;
}

export const QuickActionButtons: React.FC<QuickActionButtonsProps> = ({
  onActionClick,
  isSmallWindow,
}) => {
  const { t: tLibrary } = useTranslation('pleri/library');
  const { data: integrations } = useGetTenantIntegrations();
  const hasCodeRepoIntegration = integrations?.some(
    (integration) =>
      ['github', 'gitlab', 'bitbucket'].includes(
        integration.provider?.toLowerCase() ?? '',
      ) && integration.enabled,
  );

  const categoryItemsMap = useMemo(() => {
    const map = new Map<string, LibraryItem[]>();
    const allItems = [...libraryItems(tLibrary), ...dashboardItems(tLibrary)].filter(
      (item) =>
        item.id !== 'code-security-assessment' || hasCodeRepoIntegration,
    );
    chatPageCategories(tLibrary).forEach((category) => {
      map.set(
        category.id,
        allItems.filter(
          (item: LibraryItem) => item.chatPageCategory === category.id,
        ),
      );
    });
    return map;
  }, [hasCodeRepoIntegration]);

  const handleButtonClick = (category: ChatPageCategory) => {
    const categoryItems = categoryItemsMap.get(category.id) || [];
    onActionClick?.(category.name, category.icon, categoryItems);
  };

  return (
    <div
      className={`${
        isSmallWindow
          ? 'mx-4 mt-4 grid grid-cols-2 gap-2 px-8'
          : 'mt-4 flex flex-nowrap items-center justify-center gap-2'
      }`}
    >
      {chatPageCategories(tLibrary).map((category) => {
        return (
          <div key={category.id} className={isSmallWindow ? 'w-full' : ''}>
            <QuickActionButton
              name={category.name}
              icon={category.icon}
              onClick={() => handleButtonClick(category)}
              isFullWidth={isSmallWindow}
            />
          </div>
        );
      })}
    </div>
  );
};
